export default __webpack_public_path__ + "static/media/buffaloBills@2x.f9ba518b.jpg";